import { Map } from "immutable";
import moment from "moment";

export const getRequests = (state) => state.requests;

export const getIsRequesting = (state, requestName) => {
	const request = getRequests(state).get(requestName, Map());
	const requestSent = moment.isMoment(request.getIn(["sent"], null));
	const requestReceived = moment.isMoment(request.getIn(["received"], null));

	return requestSent && !requestReceived;
};

/**
 * Will return a boolean whether any items in the requestNameList are currently
 * being requested.
 * @param {state} state - the state
 * @param {array} requestNameList - a list of request names
 */
export const getIsRequestingAny = (state, requestNameList) => {
	let isRequesting = false;

	for (let ii = 0; ii < requestNameList.length; ii += 1) {
		isRequesting = getIsRequesting(state, requestNameList[ii]);

		if (isRequesting) {
			break;
		}
	}

	return isRequesting;
};

export const didRequestFail = (state, requestName) => {
	const request = getRequests(state).get(requestName, Map());
	return request.get("succeeded", null) === false;
};
